import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var YandexIdWhite = function YandexIdWhite(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.194 5.41H12.8c-2.554 0-3.896 1.28-3.896 3.178 0 2.153.93 3.152 2.838 4.434l1.574 1.05-4.54 6.742h-3.38l4.076-6.024c-2.348-1.666-3.664-3.28-3.664-6.023C5.808 5.333 8.208 3 12.774 3h4.541v17.814h-3.122V5.409z",
    fill: "#fff"
  }));
};
export default YandexIdWhite;